const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRouteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.986 504.986",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0dcaf0"
    },
    cx: 47.693,
    cy: 457.644,
    r: 19.638
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "whitesmoke"
    },
    d: "M476.932,235.31c0-10.521-9.118-19.638-19.638-19.638s-19.638,9.118-19.638,19.638 c0,10.521,9.118,19.638,19.638,19.638S476.932,246.531,476.932,235.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f6be00"
    },
    d: "M361.907,28.405c-24.548,0-44.186,19.638-44.186,44.186c0,16.833,23.847,63.825,44.186,98.893 c20.34-35.77,44.186-82.06,44.186-98.893C406.093,48.044,386.455,28.405,361.907,28.405z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d6efd"
    },
    d: "M457.293,187.616c-21.742,0-39.978,14.027-45.589,33.666H128.351 c-38.575,0-69.436,30.86-69.436,69.436s30.86,69.436,69.436,69.436h248.285c23.145,0,41.381,18.937,41.381,41.381 c0,23.145-18.937,41.381-41.381,41.381H93.282c-6.312-19.638-24.548-33.666-45.589-33.666C21.041,409.249,0,430.992,0,456.942 c0,26.652,21.742,47.693,47.693,47.693c21.742,0,39.978-14.027,45.589-33.666h283.353c38.575,0,69.436-30.86,69.436-69.436 s-30.86-69.436-69.436-69.436H128.351c-23.145,0-41.381-18.937-41.381-41.381c0-23.145,18.937-41.381,41.381-41.381h283.353 c6.312,19.638,23.847,33.666,45.589,33.666c26.652,0,47.693-21.742,47.693-47.693S483.244,187.616,457.293,187.616z M47.693,477.282c-10.521,0-19.638-9.118-19.638-19.638c0-10.521,9.118-19.638,19.638-19.638s19.638,9.118,19.638,19.638 C67.332,468.164,58.915,477.282,47.693,477.282z M457.293,254.948c-10.521,0-19.638-9.118-19.638-19.638 c0-10.521,9.118-19.638,19.638-19.638s19.638,9.118,19.638,19.638C476.932,246.531,467.814,254.948,457.293,254.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0d6efd"
    },
    d: "M373.83,206.553c9.819-16.132,60.318-99.595,60.318-133.962c0-39.978-32.263-72.241-72.241-72.241 s-72.241,32.263-72.241,72.241c0,34.367,50.499,117.83,60.318,133.962C355.595,215.671,368.219,215.671,373.83,206.553z M361.907,28.405c24.548,0,44.186,19.638,44.186,44.186c0,16.833-23.847,63.825-44.186,98.893 c-20.34-35.77-44.186-82.06-44.186-98.893C317.721,48.044,337.359,28.405,361.907,28.405z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0d6efd"
    },
    cx: 361.907,
    cy: 68.384,
    r: 14.027
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteIcon);
export default __webpack_public_path__ + "static/media/routeIcon.bd3b2d5e570edf9216b1a09d0081cee3.svg";
export { ForwardRef as ReactComponent };